import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { ThemeConstants } from '../../styles'

export default makeStyles((theme: Theme) =>
  createStyles({
    loadingButton: { margin: theme.spacing(ThemeConstants.BASE_SPACING, 0) },
  })
)
